export default __webpack_public_path__ + "static/media/Thb_Logo.29b0b815.jpeg";